import Store from 'lightningjs-redux';
import { isTopLevelRoute } from '../../logic/routing/routing.selectors';

const mapControllers = instance => [
  {
    selector: isTopLevelRoute,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.hasSideNav = value;
    },
  },
];

export default Store.control(mapControllers);
